class FloatingMenu extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('[data-menu-toggle]');
    if (!this.btn) return;
    this.btn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggle();
    });
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  toggle() {
    this.hasAttribute('data-open') ? this.close() : this.open();
  }

  open() {
    this.setAttribute('data-open', '');
    this.btn.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.removeAttribute('data-open');
    this.btn.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('floating-menu', FloatingMenu);
